import { UTM_KEYS } from '@/constants/gtm';
import { UTMKey } from '@/types/tracking';
import { fromPairs, includes, isEmpty, pickBy } from 'lodash';
import { useEffectOnce, useLocalStorage } from 'react-use';

export const useManageHubspotMetadata = () => {
  const [, setHubspotMetadata] = useLocalStorage<
    Partial<Record<UTMKey, string>>
  >('hubspot_metadata', {});

  useEffectOnce(() => {
    if (typeof window === 'undefined') return;

    const urlParams = new URLSearchParams(window.location.search);
    const urlParamsEntries = Array.from(urlParams.entries());

    const utmData: Partial<Record<UTMKey, string>> = urlParamsEntries
      ? pickBy(fromPairs(urlParamsEntries), (_, key) => includes(UTM_KEYS, key))
      : {};

    if (!isEmpty(utmData)) {
      setHubspotMetadata(utmData);
    }
  });
};
